(ns common.datascript.util
  (:require [clojure.walk :as walk]
            [common.datascript.schema :as ds]
            [datascript.core :as d]
            [datascript.db :refer [reverse-ref]]))

(defn transform-pull-tree
  "Apply transformations to the tree resulting from a pull from the DataScript DB.

  The `transform-entity-fn` is a function with two arguments. The first argument
  must be a keyword indicating the entity to be transformed, the second argument
  is a tree. The function must return (an adjusted) tree."
  [transform-entity-fn tree]
  (walk/postwalk
   (fn [e]
     (if (map? e)
       (let [entity-types (into #{}
                                (comp (map namespace)
                                      (keep keyword))
                                (keys e))]
         (reduce (fn [acc entity-type]
                   (transform-entity-fn entity-type acc))
                 e
                 entity-types))
       e))
   tree))

(defn sync-many [container-eid ref-attr current-values to-be-values construct-fn]
  (if (empty? to-be-values)
    ;; don't bother to calculate the changes, just delete all existing values
    (for [[eid] current-values]
      [:db/retractEntity eid])
    ;; otherwise, find out which existing values need to be deleted, and which
    ;; new values need to be added, all without touching existing values that
    ;; need to remain
    (let [removed? #(not (contains? (set to-be-values) %))
          added? #(not (contains? (into #{} (map second) current-values) %))]
      (concat (for [[eid v] current-values :when (removed? v)]
                [:db/retractEntity eid])
              (for [v to-be-values :when (added? v)]
                (assoc (construct-fn v)
                       (reverse-ref ref-attr)
                       container-eid))))))

(defn db->tx-data [db]
  (for [[e a v] (d/datoms db :eavt)
        :when (not (ds/calculated? ds/schema a))]
    [:db/add (str e) a
     (cond-> v (ds/ref? ds/schema a) str)]))
